import { render, staticRenderFns } from "./LeaveTypeList.vue?vue&type=template&id=453cf534"
import script from "../../controllers/leave_type/leave-type-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/leave_type/leave-type-list.js?vue&type=script&lang=js&external"
import style0 from "./LeaveTypeList.vue?vue&type=style&index=0&id=453cf534&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports